module.exports = __webpack_public_path__ + "static/week_week5_spot4-b02236728a4ef0d9afa5e78fdc588526.jpg";